import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "address-modal" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 col-mobile-12" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-6 col-md-6 col-mobile-12" }
const _hoisted_6 = { class: "col-lg-6 col-md-6 col-mobile-12" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-lg-6 col-md-6 col-mobile-12" }
const _hoisted_9 = { class: "col-lg-6 col-md-6 col-mobile-12" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-lg-6 col-md-6 col-mobile-12" }
const _hoisted_12 = { class: "col-lg-6 col-md-6 col-mobile-12" }

import { $api } from "@/services/api";
import { computed, reactive, watch, ref } from "vue";
import Modal from "@/components/shared/Modal.vue";
import type { FieldSchema } from "@/models/form";
import BaseFormField from "@/components/shared/BaseFormField.vue";
import { useStore } from "vuex";
import NextButton from "@/components/shared/NextButton.vue";
import Step from "@/components/shared/Step.vue";
import useValidation from "@/use/validation";
import type { Applicant, Address } from "@/models/application";
import type { Stipulation } from "@/models/opal";
import type { AddressInputRequest, StipulationInputRequest } from "@/models/api";

interface Props {
  address?: Address;
  applicant: Applicant;
  stipulation: Stipulation;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CurrentAddressFormModal',
  props: {
    address: {},
    applicant: {},
    stipulation: {}
  },
  emits: ["success"],
  setup(__props: any, { emit: __emit }) {

const store = useStore();

const props = __props;

const emit = __emit;

const { validateForm, validateAddressLine2Fields } = useValidation();
let currentAddressForm = reactive({} as any);
currentAddressForm = store.state.forms.currentAddressForm;

const addingAddress = ref<boolean>(false);

async function addAddress() {
  addingAddress.value = true;
  const valid = validateForm(addressSchema, currentAddressForm);
  if (valid) {
    store.dispatch("forms/setCurrentAddressForm", currentAddressForm);

    const addressInputRequest = store.getters["forms/AddressInputRequest"];

    const request = {
      applicationStipulationId: props.stipulation?.id,
      applicationId: props?.stipulation?.applicationId,
      addressInput: addressInputRequest as AddressInputRequest,
    } as StipulationInputRequest;

    const response = await $api.applications.addStipInput(
      props?.stipulation?.applicationId,
      request,
    );

    if (response && !response?.error) {
      // updates stip status to pending
      let updatedAddressVerificationStip = props.stipulation;
      updatedAddressVerificationStip.stipulationStatusId = response.stipulationStatusId;
      updatedAddressVerificationStip.stipulationStatusName = response.stipulationStatusName;

      emit("success", updatedAddressVerificationStip);

      store.dispatch("forms/resetCurrentAddressForm");
      store.dispatch("modal/closeCurrentAddressModal");
    } else {
      addingAddress.value = false;
    }
  } else {
    addingAddress.value = false;
  }
}

const addressSchema = reactive({
  address1: {
    name: "addrLine1",
    type: "text",
    subtype: "address",
    label: "Permanent Street Address",
    placeholder: "Street",
    required: true,
    maxLength: 50,
  } as FieldSchema,
  address2: {
    name: "addrLine2",
    type: "text",
    subtype: "address",
    label: "Unit Number",
    placeholder: "Unit #",
    required: false,
    maxLength: 25,
  } as FieldSchema,
  addressUnitTypeId: {
    name: "addressUnitTypeId",
    type: "select",
    subtype: "address",
    label: "Unit Type",
    required: false,
  } as FieldSchema,
  city: {
    name: "city",
    type: "text",
    label: "City",
    subtype: "address",
    placeholder: "City",
    required: true,
    maxLength: 40,
  } as FieldSchema,
  stateId: {
    name: "stateId",
    type: "select",
    subtype: "address",
    label: "State",
    required: true,
  } as FieldSchema,
  postalCode: {
		name: "postalCode",
    type: "zipcode",
    label: "Zip",
    placeholder: "Zip",
    errorMessage: "Zip code is required.",
    required: true,
  } as FieldSchema,
  countryId: {
		name: "countryId",
    type: "select",
    label: "Country",
    required: true,
  } as FieldSchema,
});

const states = computed(() => store.getters["lookupsModule/statesOptions"]);
const countries = computed(() => store.getters["lookupsModule/countryOptions"]);
const unitTypes = computed(() => store.getters["lookupsModule/addressUnitsOptions"]);

watch(
  () => currentAddressForm.addressUnitTypeId,
  value => {
    validateAddressLine2Fields(
      addressSchema.addressUnitTypeId,
      addressSchema.address2,
      currentAddressForm.addressUnitTypeId,
      currentAddressForm.address2,
    );
  },
  { immediate: true },
);

watch(
  () => currentAddressForm.address2,
  value => {
    validateAddressLine2Fields(
      addressSchema.addressUnitTypeId,
      addressSchema.address2,
      currentAddressForm.addressUnitTypeId,
      currentAddressForm.address2,
    );
  },
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, null, {
    default: _withCtx(() => [
      _createVNode(Step, null, {
        actions: _withCtx(() => [
          _createVNode(NextButton, {
            text: "Save Address",
            onClick: addAddress,
            disabled: addingAddress.value
          }, null, 8, ["disabled"])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(BaseFormField, {
                  schema: addressSchema.address1,
                  modelValue: _unref(currentAddressForm).address1,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(currentAddressForm).address1) = $event))
                }, null, 8, ["schema", "modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(BaseFormField, {
                  schema: addressSchema.addressUnitTypeId,
                  modelValue: _unref(currentAddressForm).addressUnitTypeId,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(currentAddressForm).addressUnitTypeId) = $event)),
                  modelModifiers: { number: true },
                  options: unitTypes.value
                }, null, 8, ["schema", "modelValue", "options"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(BaseFormField, {
                  schema: addressSchema.address2,
                  modelValue: _unref(currentAddressForm).address2,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(currentAddressForm).address2) = $event)),
                  autocomplete: "address-line2"
                }, null, 8, ["schema", "modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(BaseFormField, {
                  schema: addressSchema.city,
                  modelValue: _unref(currentAddressForm).city,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(currentAddressForm).city) = $event))
                }, null, 8, ["schema", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(BaseFormField, {
                  schema: addressSchema.stateId,
                  modelValue: _unref(currentAddressForm).stateId,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(currentAddressForm).stateId) = $event)),
                  modelModifiers: { number: true },
                  options: states.value
                }, {
                  "default-option": _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode(" State ", -1)
                  ]))]),
                  _: 1
                }, 8, ["schema", "modelValue", "options"])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(BaseFormField, {
                  schema: addressSchema.postalCode,
                  modelValue: _unref(currentAddressForm).postalCode,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(currentAddressForm).postalCode) = $event))
                }, null, 8, ["schema", "modelValue"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(BaseFormField, {
                  schema: addressSchema.countryId,
                  modelValue: _unref(currentAddressForm).countryId,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(currentAddressForm).countryId) = $event)),
                  modelModifiers: { number: true },
                  options: countries.value
                }, {
                  "default-option": _withCtx(() => [...(_cache[8] || (_cache[8] = [
                    _createTextVNode(" Country ", -1)
                  ]))]),
                  _: 1
                }, 8, ["schema", "modelValue", "options"])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})